import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { ENDPOINT } from "../../../constants/endpointConstants";
import { getToken, formatDateTime, getRangeDates } from "../../../utils/utils";
import Table from "../../../components/Table";

const InsightExpensesTable = ({ startDate, endDate }) => {
  const [categories, setCategories] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [sortBy, setSortBy] = useState("totalPrice");
  const [sortDirection, setSortDirection] = useState("desc");
  const size = 10;

  const fetchExpenses = useCallback(async () => {
    const token = getToken();
    setLoading(true);
    try {
      const [dateInitFormatted, dateFinishFormatted] = getRangeDates(
        startDate,
        endDate
      );

      const { data } = await axios.post(
        ENDPOINT.GET_REPORT_EXPENSES_BY_CATEGORY,
        {
          startDate: formatDateTime(dateInitFormatted),
          endDate: formatDateTime(dateFinishFormatted),
          page,
          size,
          sortBy,
          sortDirection,
        },
        token
      );

      setCategories(data.categories || []);
      setTotalItems(data.totalItems || 0);
    } catch (error) {
      console.error("Error fetching expenses by category:", error);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate, page, size, sortBy, sortDirection]);

  useEffect(() => {
    fetchExpenses();
  }, [fetchExpenses]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleSortChange = (newSortBy) => {
    const isSameColumn = newSortBy === sortBy;
    const newSortDirection =
      isSameColumn && sortDirection === "asc" ? "desc" : "asc";
    setSortBy(newSortBy);
    setSortDirection(newSortDirection);
    setPage(1);
  };

  const columnNames = [
    {
      name: "Id",
      key: "customId",
      sortKey: "customId",
    },
    {
      name: "Nombre",
      key: "categoryName",
      sortKey: "categoryName",
    },
    {
      name: "Precio Total",
      key: "totalPrice",
      type: "currency",
      sortKey: "totalPrice",
    },
    {
      name: "Cantidad",
      key: "totalAmount",
      sortKey: "totalAmount",
    },
    {
      name: "N de gastos",
      key: "expenseCount",
      sortKey: "expenseCount",
    },
    {
      name: "Unidad",
      key: "unitType",
      sortKey: "unitType",
    },
  ];

  return (
    <Table
      columnNames={columnNames}
      items={categories}
      isLoading={loading}
      pagination={true}
      totalItems={totalItems}
      currentPage={page}
      itemsPerPage={size}
      onPageChange={handlePageChange}
      sortBy={sortBy}
      sortDirection={sortDirection}
      onSortChange={handleSortChange}
    />
  );
};

export default InsightExpensesTable;
